import React from "react";
import { UploadedImageLoaderTemplate } from "themes/common/components";

function UploadedImageLoader(props) {
    return <UploadedImageLoaderTemplate {...props} />;
}

export default UploadedImageLoader;
